var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-content',[_c('div',{attrs:{"id":"core-view"}},[_c('v-fade-transition',{attrs:{"mode":"out-in"},on:{"after-leave":function($event){return _vm.$root.$emit('triggerScroll')}}},[_c('router-view')],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }